module.exports = __webpack_public_path__ + "img/empty-data.png?3a6e5f99";